import React, { useState } from "react";
import { enquiryApi } from "../api/client";
import bgmain from "../../src/Images/main.jpg";
import { popoverClasses } from "@mui/material";

export default function EnquiryForm() {
  const [role, setRole] = useState("Channel Partner");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "Channel Partner",
    capacity: "",
    experience: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // ✅ Phone field: allow only numbers & max 10 digits
    if (name === "phone") {
      if (!/^\d*$/.test(value)) return; // only digits allowed
      if (value.length > 10) return; // max length 10
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Extra validation (frontend)
    if (!/^\d{10}$/.test(formData.phone)) {
      alert("❌ Please enter a valid 10-digit phone number!");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      alert("❌ Please enter a valid email address!");
      return;
    }

    try {
      await enquiryApi.submitEnquiry(formData);
      alert("✅ Form submitted successfully!");

      setFormData({
        name: "",
        email: "",
        phone: "",
        role: "Channel Partner",
        capacity: "",
        experience: "",
        description: "",
      });
      setRole("Channel Partner");
    } catch (err) {
      console.error(err);
      alert("❌ Error submitting form!");
    }
  };

  return (
    <>
      <section className="min-h-screen w-full flex items-center fl">
        <img
          src={bgmain}
          alt="Hero Background"
          className="absolute min-h-screen inset-0 w-full h-full object-cover z-[-10] blur-sm"
        />
        <div className="w-11/12 md:w-6/12 mx-auto px-3 py-3 poppins-regular flex justify-center items-center bg-gray-100/30 backdrop-blur-sm rounded-lg">
          <form
            onSubmit={handleSubmit}
            className=" p-8 rounded-2xl  w-full max-w-4xl space-y-6"
          >
            <h2 className="text-2xl font-bold text-center text-gray-900 mb-5 uppercase">
              Partner Enquiry Form
            </h2>

            {/* Name and Email */}
            <div className="grid grid-cols-2  gap-6">
              <div className=" items-center gap-3">
                <label className="w-32 font-medium text-gray-900">Name:</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="   Enter your name"
                  className="w-full border border-gray-300 rounded-lg px-1 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                />
              </div>

              <div className="items-center gap-3">
                <label className="w-32 font-medium text-gray-900">Email:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                />
              </div>
            </div>

            {/* Phone and Role */}
            <div className="grid grid-cols-2 gap-6">
              <div className="items-center gap-3">
                <label className="w-32 font-medium text-gray-900">Phone:</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Enter 10-digit number"
                  maxLength="10"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                />
              </div>

              <div className="items-center gap-3">
                <label className="w-32 font-medium text-gray-900">Role:</label>
                <div
                  name="role"
                  value={formData.role}
                  onChange={(e) => {
                    setRole(e.target.value);
                    handleChange(e);
                  }}
                  className="w-full border border-gray-300 bg-white rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                >
                  {/* <option value="Promoter">Promoter</option> */}
                  <option value="Channel Partner">Channel Partner</option>
                </div>
              </div>
            </div>

            {/* Channel Partner - Capacity */}
            {/* {role === "Channel Partner" && (
            <div className="items-center gap-3">
              <label className="w-32 font-medium text-gray-900">
                Capacity:
              </label>
              <input
                type="text"
                name="capacity"
                value={formData.capacity}
                onChange={handleChange}
                placeholder="Enter your capacity"
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              />
            </div>
          )} */}

            {/* Experience */}
            <div className="items-center gap-3">
              <label className="w-32 font-medium text-gray-900">
                Experience:
              </label>
              <input
                type="text"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                required
                placeholder="Enter your experience"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              />
            </div>

            {/* Description */}
            <div className="items-start gap-3">
              <label className="w-32 font-medium text-gray-900 mt-2">
                Description:
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                placeholder="Enter description"
                rows="2"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
              ></textarea>
            </div>

            {/* Submit */}
            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-blue-600 text-white px-8 py-2 rounded-lg hover:bg-blue-700 transition font-medium"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
